/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { Flex } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaChevronDown, FaChevronUp, FaEnvelopeOpenText, FaPaperPlane } from 'react-icons/fa'
import { IoMail } from 'react-icons/io5'
import { MdOutlineSmartphone } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { UsuarioGestaoConviteDto } from '../..'
import { ButtonCmp } from '../../../../../../components/ButtonCmp'
import { CheckboxCmp } from '../../../../../../components/CheckboxCmp'
import { ElementoTooltipCmp } from '../../../../../../components/ElementoTooltipCmp'
import { TableDiv } from './styles'

interface iTabelaprops {
  rows: UsuarioGestaoConviteDto[]
  pesquisaId?: string
  selecionados?: string[]
  onCheck: (id: string, all?: boolean) => void
  onSend: (email: string) => void
  isEdit?: boolean
  iniciada: boolean
  pesquisaEncerrada?: boolean
}

export const TableConvites: React.FC<iTabelaprops> = ({ rows, pesquisaId, isEdit, selecionados, onCheck, onSend, pesquisaEncerrada, iniciada }) => {
  const [Rows, setRows] = useState<UsuarioGestaoConviteDto[]>([])
  const nav = useNavigate()

  useEffect(() => {
    setRows(rows)
  }, [rows])

  const [Ordenacao, setOrdenacao] = useState(false)
  const [UltimoFiltro, setUltimoFiltro] = useState<number>()

  function SelecionarTodos(check: boolean): void {
    onCheck('', check)
  }

  function OrdenarTabela(filtro: number): void {
    if (!(!Ordenacao && UltimoFiltro !== filtro)) {
      setOrdenacao(!Ordenacao)
    }
    setUltimoFiltro(filtro)
  }

  useEffect(() => {
    const copy = [...rows]
    if (UltimoFiltro === 0) {
      copy.sort((a, b) => {
        const A = a.tipoConvite ?? 0
        const B = b.tipoConvite ?? 0

        if (!Ordenacao) {
          return B - A
        } else {
          return A - B
        }
      })
    }
    if (UltimoFiltro === 1) {
      copy.sort((a, b) => {
        if (!Ordenacao && a.nome && b.nome) {
          return b.nome.localeCompare(a.nome)
        } else if (Ordenacao && a.nome && b.nome) {
          return a.nome.localeCompare(b.nome)
        } else {
          return 0
        }
      })
    }
    if (UltimoFiltro === 2) {
      copy.sort((a, b) => {
        if (!Ordenacao && a.email && b.email) {
          return b.email.localeCompare(a.email)
        } else if (Ordenacao && a.email && b.email) {
          return a.email.localeCompare(b.email)
        } else {
          return 0
        }
      })
    }
    if (UltimoFiltro === 3) {
      copy.sort((a, b) => {
        if (!Ordenacao && a.nomeArea && b.nomeArea) {
          return b.nomeArea.localeCompare(a.nomeArea)
        } else if (Ordenacao && a.nomeArea && b.nomeArea) {
          return a.nomeArea.localeCompare(b.nomeArea)
        } else {
          return 0
        }
      })
    }
    if (UltimoFiltro === 4) {
      copy.sort((a, b) => {
        const A = a.status ?? 0
        const B = b.status ?? 0

        if (!Ordenacao) {
          return B - A
        } else {
          return A - B
        }
      })
    }

    setRows(copy)
  }, [Ordenacao, UltimoFiltro, rows])

  function ObterCor(e: UsuarioGestaoConviteDto): string {
    return (e.status === 0 || e.status === 1) ? 'Green2' : 'c5'
  }

  return (
    <TableDiv>
      <table>
        <thead>
          <tr>
            {isEdit && <th>
            <Flex gap={'0.50rem'}>
              <span>Selecionar todos </span>
              <CheckboxCmp OnChange={SelecionarTodos}/>
            </Flex></th>}
            <th onClick={() => OrdenarTabela(0)}>
              <div>Tipo {UltimoFiltro === 0 && !Ordenacao ? <FaChevronUp/> : <FaChevronDown/>}</div>
            </th>
            <th onClick={() => OrdenarTabela(1)}>
              <div>Nome {UltimoFiltro === 1 && !Ordenacao ? <FaChevronUp/> : <FaChevronDown/>}</div>
            </th>
            <th onClick={() => OrdenarTabela(2)}>
              <div>Email {UltimoFiltro === 2 && !Ordenacao ? <FaChevronUp/> : <FaChevronDown/>}</div>
            </th>
            <th onClick={() => OrdenarTabela(3)}>
              <div>Área {UltimoFiltro === 3 && !Ordenacao ? <FaChevronUp/> : <FaChevronDown/>}</div>
            </th>
            {!isEdit &&
              <th onClick={() => OrdenarTabela(4)}>
                <div>Status {UltimoFiltro === 4 && !Ordenacao ? <FaChevronUp/> : <FaChevronDown/>}</div>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          {
            Rows.map((e, i) => {
              return (
                <tr key={i}>
                  {isEdit && <td>
                    <CheckboxCmp isChecked={selecionados?.find(r => r === e.email) !== undefined} OnChange={() => onCheck(e.email)}/>
                  </td>}
                  <td>{e.tipoConvite === 2 ? <Flex alignItems={'center'} gap={'.5rem'} justifyContent={'center'}><IoMail /> Email</Flex> : e.tipoConvite === 0 ? <Flex alignItems={'center'} gap={'.5rem'} justifyContent={'center'}><MdOutlineSmartphone /> Aplicativo</Flex> : <Flex alignItems={'center'} gap={'.5rem'} justifyContent={'center'}><FaEnvelopeOpenText /> Carta</Flex>}</td>
                  <td>{e.nome}</td>
                  <td>{e.email}</td>
                  <td>{e.nomeArea}</td>
                  {!isEdit && <td>
                    <Flex justifyContent={'center'} gap={'1rem'} flexWrap={'wrap'}>
                      <Flex
                        gap={'.325rem'}
                        alignItems={'center'}
                      >
                        <Flex
                            width={'11px'}
                            bg={`var(--${ObterCor(e)})`}
                            height={'11px'}
                            borderRadius={'full'}
                            marginRight='.5rem'
                            alignItems={'center'}
                        />
                        {e.tipoConvite !== 1 && (e.status === 0 ? (iniciada ? 'Enviado' : 'Agendado') : 'Não enviado')}
                        {e.tipoConvite === 1 && (e.status === 4 ? 'A responder' : 'Respondido')}
                      </Flex>
                      {
                        (e.status === 3) && (
                          <ButtonCmp
                            onClick={() => onSend(e.email)}
                            leftIcon={<FaPaperPlane />}
                            VarColor='Green2'
                            small
                            isDisabled={pesquisaEncerrada}
                          >{iniciada ? 'Enviar' : 'Agendar'}</ButtonCmp>
                        )
                      }

                      {
                        (e.status === 4 && e.tipoConvite === 1) && (
                          <ButtonCmp
                            onClick={() => nav(`/Engajamento/Pec/${pesquisaId}/CartaConvite/${e.tokenId}`)}
                            leftIcon={<FaPaperPlane />}
                            VarColor='Green2'
                            small
                          >Visualizar</ButtonCmp>
                        )
                      }

                      {
                        (e.status === 0) && (
                          <ElementoTooltipCmp bg={'var(--Red)'} label={!iniciada ? 'A pesquisa ainda não foi iniciada' : ''}>
                            <ButtonCmp
                            onClick={() => onSend(e.email)}
                            leftIcon={<FaPaperPlane />}
                            VarColor='Rosa'
                            small
                            isDisabled={pesquisaEncerrada || !iniciada}
                          >Reenviar</ButtonCmp>
                          </ElementoTooltipCmp>
                        )
                      }
                    </Flex>
                  </td>}
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </TableDiv>
  )
}
